import {
  Card,
  FlatActionList,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";

export type SettingsScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "SettingsScreen"
>;

export const SettingsScreen = ({ navigation }: SettingsScreenProps) => {
  return (
    <Page title={"Settings"}>
      <Stack vertical>
        <Card title={"General Settings"}>
          <FlatActionList
            items={[
              {
                key: "background-eraser",
                title: "Background Eraser",
                subTitle: "Settings for the background eraser feature",
                onPress: () =>
                  navigation.navigate("BackgroundEraserSettingsRootScreen", {
                    screen: "BackgroundEraserSettingsScreen",
                  }),
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
